(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mmc-charge-complement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mmc-charge-complement')) {
    customElements.define('mmc-charge-complement', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.controller = new AbortController();
        this.button.addEventListener('click', () => this.addPair(), {signal:this.controller.signal});
        this.form = document.getElementById(this.dataset.form);
        this.form?.addEventListener('change', () => this.checkVariant(), {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
      checkVariant() {
        const current = this.form?.querySelector('[name="id"]')?.value;
        this.hidden = current !== this.dataset.parent;
        return !this.hidden;
      }
      async addPair() {
        if (this.dataset.ready !== 'true' || this.button.disabled) return;
        if (!this.checkVariant()) { this.status.textContent = this.status.dataset.invalid; return; }
        const quantity = Number(new FormData(this.form).get('quantity') || 1);
        if (!Number.isInteger(quantity) || quantity < 1) return;
        this.button.disabled = true;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        try {
          const root = window.Shopify?.routes?.root || '/';
          const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections = drawer?.getSectionsToRender().map(section => section.id) || [];
          const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.bundle),quantity}],sections,sections_url:location.pathname})});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(this.status.dataset.error);
          this.status.textContent = this.status.dataset.success;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate,{source:'mmc-charge-complement',cartData:result});
          if (drawer) { drawer.setActiveElement(this.button); drawer.classList.remove('is-empty'); drawer.renderContents(result); }
          else location.assign(`${root}cart`);
        } catch { this.status.textContent = this.status.dataset.error; }
        finally { this.button.disabled = false; this.removeAttribute('aria-busy'); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
